import React from 'react';
import Table from '../../components/common/Table';
import { QuestionSetDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface QuestionSetTableProps {
  data: QuestionSetDTO[];
  handleEdit: (row: QuestionSetDTO) => void;
  handleDelete: (row: QuestionSetDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const QuestionSetTable: React.FC<QuestionSetTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'No of Questions',
          key: 'questionsToShow',
        },
        {
          label: 'Order',
          key: 'displayPosition',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: QuestionSetDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default QuestionSetTable;
